// Path: ./src/app/components/Layout/index.tsx
import React from "react";
import Navigation from "../NavigationBar/TopNavBar";
import { GoFlyerAdminContext } from "../../../contextApi/context";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Backdrop, CircularProgress } from "@mui/material";
import { useLoading } from "../../../contextApi/LoadingContext";
import TestEnvBanner from "../TestEnvBanner";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";

declare global {
  interface Window {
    Tawk_API?: {
      setAttributes: (attributes: Record<string, any>) => void;
    };
  }
}

interface Props {
  children: React.ReactNode;
}

const TAWK_CUSTOM_STYLE = {
  visibility: {
    desktop: {
      xOffset: 10,
      yOffset: 60,
      position: "tr",
    },
    mobile: {
      xOffset: 10,
      yOffset: 0,
      position: "tl",
    },
  },
} as const;

const Layout = ({ children }: Props) => {
  const { isLoading } = useLoading();
  const { state } = React.useContext(GoFlyerAdminContext);
  const rawEnableTawk = process.env.REACT_APP_ENABLE_TAWK_CHAT as
    | string
    | boolean
    | undefined;
  const enableTawk = rawEnableTawk === true || rawEnableTawk === "true";

  React.useEffect(() => {
    if (
      state.gfAdminUser &&
      window.Tawk_API &&
      window.Tawk_API.setAttributes &&
      enableTawk
    ) {
      window.Tawk_API.setAttributes({
        name: state.gfAdminUser.firstName,
        email: state.gfAdminUser.email,
        userId: state.gfAdminUser.id,
      });
    }
  }, [state.gfAdminUser]);

  return (
    <>
      <Navigation isLoggedIn={state.user?.isLoggedIn} />
      <main>{children}</main>
      <TestEnvBanner />
      <Backdrop
        data-testid="Backdrop-loader"
        sx={{ color: "#ff813a", zIndex: 999999 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />{" "}
      {enableTawk ? (
        <TawkMessengerReact
          propertyId={process.env.REACT_APP_TAWK_PROPERTY_ID as string}
          widgetId={process.env.REACT_APP_TAWK_WIDGET_ID as string}
          customStyle={TAWK_CUSTOM_STYLE}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default Layout;
